import React from 'react';
import {Container, Row, Col, Figure} from 'react-bootstrap';
import './Home.css';

const Special = () => {
    return ( 
        <Container>
        <Row>
          <Col xs={12} md={12}>
          <Figure className="itemsimg">
          <Figure.Caption>
  <p><h2><span className="fontcolor">BUK COMMERCIALS SERVICES DIVISION</span></h2></p>
            <p><h4>BUK Commercials Services DIVISION prime business is to procure high end equipment such as for the mines,
road construction, fire services, sanitary garbage trucks, cranes, transformers and medical equipment etc.</h4></p>
  </Figure.Caption>
        <Figure.Image
          width={1920}
          height={844}
          alt="171x180"
          src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596747/nonedb/vehicles_xvtdui.jpg"
        />
        <Figure.Caption>
        
        </Figure.Caption>
      </Figure>  
         </Col>
        </Row>
        </Container>
     );
};
 
export default Special;